import api from '@/api';
import { PurchaseAbcCurveRequest } from './Purchase.types';
import { API_BASE_URL } from '..';

const baseUrl = API_BASE_URL;

export async function generatePurchaseAbcCurve(obj?: PurchaseAbcCurveRequest) {
  const result = (await api.getReport(
    `${baseUrl}/Purchase/AbcCurve`,
    obj,
  )) as unknown;

  return result as BlobPart;
}
